export function formatDate(epochMs: number) {
  const date = new Date(epochMs);

  return date.toLocaleDateString("de-DE", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  });
}
